export const courseData = [
  {
    course: "PGP in Sales, Marketing and Business Leadership",
    image:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21jwmcd.webp",
    imagehover:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21k05zv.webp",
    title:
      "Start your business leadership career in top companies in high potential roles of 7.5-17.5LPA. If the job < 7.5L, you get a 60% refund!",
    startAs: [
      "Sales Development Representatives",
      "Key Account Managers",
      "Inbound and Outbound Marketing",
      "Category Managers",
    ],
    link: "/sales-course/",
  },
  {
    course: "The Marketing Launchpad",
    image:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21kb9c3.webp",
    imagehover:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21kdlch.webp",
    title:
      "Start your marketing career by learning how to create and run ads, drive SEO, manage e-Com, create and build social media & more! Get placements of 4.5-9.2 LPA. If your job < 4.5L, you get a 60% refund!",
    startAs: [
      "Digital Marketing Associate",
      "Performance Marketer",
      "Content and Social Media",
      "Ecommerce Analyst & more",
    ],
    link: "/marketing-launchpad/digital-marketing-course/",
  },
  {
    course: "MLP - Emerging Talent Program (Hindi)",
    image:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21jsz08.webp",
    imagehover:
      "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m21jv81n.webp",
    title:
      "Not as good in English? Master both Digital Marketing skills and English speaking skills and get into great companies. You pay the majority of the fees after you get placed at 3L or more!",
    startAs: [
      "Digital Marketing Analyst",
      "Media Planning",
      "SEO Analyst",
      "Ecommerce Analyst",
    ],
    link: "marketing-launchpad/digital-marketing-course-in-hindi/",
  },
];
